import ServiceReports from '../../../../../services/ServiceReports';

class Service extends ServiceReports {
  constructor() {
    super('/callback');
  }
}

export default new Service();
